// extracted by mini-css-extract-plugin
export default {"eventCardVenueList":"EventCardVenueList_eventCardVenueList__Z6SHS","eventCardVenue":"EventCardVenueList_eventCardVenue__3M5RE"};